import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { TranslateService }        from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';
import { CrudGridService, CrudGridInstance } from '../grids/crud-grid.service';

import { CustomerSourceModel } from './models/customer-source';

@Component({
  selector   : 'wor-company-lists-customer-sources',
  template: require('./company-lists.customer-sources.component.html')
})
export class CompanyListsCustomerSourcesComponent implements OnInit {
  @Input() customerSources: Array<CustomerSourceModel> = [];

  crudGrid: CrudGridInstance<CustomerSourceModel>;
  collapsed = false;

  constructor (
    private apiService: ApiService,
    private confirmService: ConfirmService,
    private crudGridService: CrudGridService,
    private messagesService: MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {


    this.crudGrid = this.crudGridService.create<CustomerSourceModel>();


    this.crudGrid.data = this.customerSources;


  }

  removeRow(source: CustomerSourceModel, index: number): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_TEMPLATE'))
      .then(() => this.crudGrid.removeRow(source, index, '/customer_sources', 'id'))
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.CUSTOMER_SOURCE'), 'success');
        this.crudGrid.data.splice(index, 1);
      });
  }

  saveRow(source: CustomerSourceModel, index: number): void {
    const method = source.id ? 'patch' : 'post';
    const url    = source.id ? '/customer_source' : '/customer_sources';

    this.apiService[method](url, source, 'customer_source')
      .then((sources: Array<CustomerSourceModel>) => {
        this.crudGrid.data = source.id ? this.crudGrid.data : sources;
        this.crudGrid.toggleEditMode(source, index);
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.CUSTOMER_SOURCE'), 'success');
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }

  toggle (): void {


    this.collapsed = !this.collapsed;


    };


  }
